(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('signInManager', signInManager);

    var rGuid = /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/i,
        isNumber = angular.isNumber;

    signInManager.$inject = ['$q', '$state', 'localStorageService', 'OpenId', 'user', 'tokenStorageKey', 'loginStateName', 'core_resources', 'openIdGrantTypes'];
    function signInManager($q, $state, $localStorage, OpenId, user, tokenStorageKey, loginStateName, resources, openIdGrantTypes) {
        return {
            signIn: proxyify(signIn, 'signIn'),
            signOut: proxyify(signOut, 'signOut'),
            isSignedIn: proxyify(isSignedIn, 'isSignedIn'),
            refresh: proxyify(refresh, 'refresh')
        };

        // API
        // 1) signIn('grant', '123456)
        // 2) signIn('50D4F779-BE82-4D27-86E8-85D4C9855C0E')
        // 3) signIn(123, 'TWFuIGlzIGRpc3Rpbmd1aXNoZWQsIG5vdCBvbmx5IGJ5IGhpcyByZWFzb24sIGJ1dCBieSB0aGlz')
        function signIn() {
            var params = { };
            removeUserAndToken();

            if (arguments.length === 1 && rGuid.test(arguments[0])) {
                params.grant_type = openIdGrantTypes.guid;
                params.guid = arguments[0]
            }
            else if (arguments.length > 1 && isNumber(arguments[0])){
                params.grant_type = openIdGrantTypes.hash;
                params.id = arguments[0];
                params.hash = arguments[1];
            }
            else {
                params.grant_type = openIdGrantTypes.password;
                params.username = arguments[0];
                params.password = arguments[1];
            }

            return OpenId.getToken(params, true).$promise.then(success);
        }

        function signOut(suppressRedirect) {
            removeUserAndToken();
            if (suppressRedirect !== true)
                $state.go(loginStateName);
            
            return $q.resolve(null);
        }

        function isSignedIn() {
            var token = $localStorage.get(tokenStorageKey),
                refreshToken;

            if (!token) {
                return $q.reject(resources.userNotLoggedIn);
            }
            else if (token.expire_date < Date.now() || !user.id) {
                refreshToken = token.refresh_token;
                removeUserAndToken();
                return OpenId.refreshToken({ refresh_token: refreshToken }).$promise.then(success);
            }
            else {
                return $q.resolve(token);
            }
        }

        function refresh() {
            var token = $localStorage.get(tokenStorageKey),
                refreshToken;

            if (!token) {
                return $q.reject(resources.userNotLoggedIn);
            }
            else {
                refreshToken = token.refresh_token;
                return OpenId.refreshToken({ refresh_token: refreshToken }, true).$promise.then(success);
            }
        }

        // Helpers
        function proxyify(func, name) {
            proxyify.pending = proxyify.pending || $q.when();

            return function proxy() {
                var that = this,
                    args = arguments;

                // Wait for pending sign in method completion.
                return proxyify.pending = proxyify.pending.then(callFunc, callFunc);

                function callFunc() {
                    return func.apply(that, args);
                }
            }
        }
        function success(data) {
            return saveUserAndToken(data);
        }

        function saveUserAndToken(token) {
            var userData = token.user,
                oldId = user.id,
                oldAdminMode = user.adminMode;

            // delete token.user; <=== we will leave it in for the remote black bar.
            angular.copy(userData, user);

            // This is sack!
            if (user.id === oldId) 
                user.adminMode = oldAdminMode;

            return $localStorage.set(tokenStorageKey, token) && token;
        }

        function removeUserAndToken() {
            $localStorage.remove(tokenStorageKey);
            angular.copy({}, user);
        }
    }
})();